import { jsonParser } from "./jsonParser";
import { getProfileDetails } from "./API";
import { ToastEmitter } from "../components/DoctorMangement/ToastEmitter";
import { RBAC_UNAUTHORIZED_MESSAGE } from "../components/SPOC/constant";
import { getRoles } from "../components/SPOC/Helper/API";
import { SESSION_STORAGE_KEYS } from "../constants/provider/constant";
export const getUserDetailsFromAccessToken = async () => {
    try {
        const accessToken = localStorage.getItem('access_token');
        const userFeatures=jsonParser(localStorage.getItem('userFeatures'));
        let resp;
        if(accessToken) {
            const accesstoken = jsonParser(accessToken);
             resp =  await getProfileDetails(accesstoken, userFeatures);
            if(resp?.data?.isSuccess){
                const profileData = resp.data;
                
                if(profileData.userProfile?.allowPushNotifications !== undefined) {
                    localStorage.setItem('allowPushNotifications', profileData.userProfile.allowPushNotifications);
                }
                if(profileData.userProfile?.refreshRate) {
                    localStorage.setItem('refreshRate', profileData.userProfile.refreshRate);
                }
                
                const { syncDataToServiceWorker } = await import('../serviceWorkerRegistration');
                syncDataToServiceWorker();
                
                return profileData.userProfile;
            }

        }
        ToastEmitter("Something Went wrong Plese Login Again", 'error')
        localStorage.clear();
        return null;
    }
    catch (err){
        if (err?.response?.status === 401)
            ToastEmitter("Login session expired Plese Login Again", 'error')
        else if (err?.response?.status === 409)
            ToastEmitter("Your profile has been updated by the admin. Please log in again.", 'error')
        else
            ToastEmitter("Something Went wrong Plese Login Again", 'error')
        localStorage.clear();
        return null;
    }
   
}


export const checkFeatureFeasbility = (featureName, userFeatures)=>{
    if (userFeatures && userFeatures.length > 0 && userFeatures.includes(featureName)) {
        return true;

    }
    else {
        return false
    }
}

export function returnRoleBasedOnRoleId(roleId) {
    switch (roleId) {
      case 5432: return 'dcadmin';
      case 5433: return 'dcoperations';
      case 5434: return 'dcoperations';
      case 9207: return 'insureradmin';
      case 9211: return 'insureragent';
      case 9214: return 'insurerbranch';
      case 9217: return 'mareport';
      case 9219: return 'insurercallCentre';
      default: return null;
    }
  }


  export const unauthorizedErrorToastEmitter = (error)=>{
    (error?.response?.status === 403 ?
        ToastEmitter(RBAC_UNAUTHORIZED_MESSAGE ,"error")
        : <></>
    );
  }


  export const getDepartmentsFromRoles = (userRoles) => {
    try {
        const labDepartment = new Set();
        const OFCDepartment = new Set();
        const labSelectedDepartment = [];
        const OFCselectedDepartment = [];
        const specialityMap = JSON.parse(localStorage.getItem(SESSION_STORAGE_KEYS.SPECIALITY_ARRAY) || '{}');

        userRoles?.map((role) => {
            const roleName = role?.roleName || role?.name
            const splitName = roleName?.split('/*/');
            if (splitName?.length > 1) {
                const roleDept = splitName[0].split('/');
                if (roleDept.length > 1) {
                    if (roleDept[0].toLowerCase() == 'lab' && !labDepartment.has(roleDept[1])) {
                        labSelectedDepartment.push({
                            label: roleDept[1].replaceAll('_', ' '), //this is roleLabel
                            value: roleDept[1].replaceAll('_', ' ') //need to replace with the roleName 
                        })
                        labDepartment.add(roleDept[1])
                    }
                    if (roleDept[0].toLowerCase() == 'ofc') {
                        let specialityId = roleDept[1];
                        if(specialityId.includes('^')){
                            specialityId = specialityId.split('^')[1];
                        }
                        const specialityName  = specialityMap[specialityId];
                        if(specialityName != undefined && !OFCDepartment.has(specialityName) ) {
                            OFCselectedDepartment.push({
                                label: specialityName, //this is roleLabel
                                value: specialityName //need to replace with the roleName
                            })
                            OFCDepartment.add(specialityName)
                        }
                    }
                }
            } 
        });
        return {labSelectedDepartment, OFCselectedDepartment}

    } catch (error) { 
    }
}

export  const getDepartments = async (setOFCDepartment, setLabDepartment)=>{
    const rolesArray = await getRoles();
    const {labSelectedDepartment, OFCselectedDepartment} = getDepartmentsFromRoles(rolesArray?.roles);
    setLabDepartment(labSelectedDepartment);
    setOFCDepartment(OFCselectedDepartment);
}
  